export const title = 'Medewerker toevoegen';
export const backButtonText = 'Terug';
export const addUserButtonText = 'Medewerker toevoegen';
export const roleToCreateUserText = 'Kies een rol';
export const noResultsTitle = 'Niets gevonden...';
export const noResultsText = 'Met deze filterselectie zijn er geen medewerkers';
